


import React, { useState, useEffect } from "react";
import { Row, Card, CardBody, Button, Label, Col } from "reactstrap";
import Select from "react-select";
import { ToastContainer, toast, Bounce } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

// EditCourseRegistration - Option 3 (final working)
// Replace your existing file content with this component.

const EditCourseRegistration = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    document.title = "Technical Hub | Edit Course Registration";

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const backendImgUrl = process.env.REACT_APP_BACKEND_IMAGE_URL;

    // Option lists
    const [courses, setCourses] = useState([]);
    const [technologies, setTechnologies] = useState([]);
    const [technologyLogoDetails, setTechnologyLogoDetails] = useState([]);
    const [passoutYearList, setPassoutYearList] = useState([]);
    const [certificationOptions, setCertificationOptions] = useState([]);
    const [collegeList, setCollegeList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [cashierNames, setCashierNames] = useState([]);
    const [trainers, setTrainers] = useState([]);

    // selection & form state
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedTechnology, setSelectedTechnology] = useState(null);
    const [selectedTechnologyLogo, setSelectedTechnologyLogo] = useState(null);

    const [programName, setProgramName] = useState("");
    const [appProgram, setAppProgram] = useState("");
    const [fee, setFee] = useState("");
    const [seats, setSeats] = useState("");
    const [noOfTerms, setNoOfTerms] = useState("");
    const [termFeeDetails, setTermFeeDetails] = useState([{ term_name: "", amount: "", status: "", endDate: "" }]);
    const [termNameOptions, setTermNameOptions] = useState([]);

    const [selectedGender, setSelectedGender] = useState(null);
    const [selectedPassoutYear, setSelectedPassoutYear] = useState(null);
    // const [selectedScholarType, setSelectedScholarType] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedRegistrationStatus, setSelectedRegistrationStatus] = useState(null);

    const [eligibleRollNos, setEligibleRollNos] = useState("");
    const [selectedColleges, setSelectedColleges] = useState([]);
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [selectedEligibleYears, setSelectedEligibleYears] = useState([]);
    const [selectedCashiers, setSelectedCashiers] = useState([]);

    const [selectedMentors, setSelectedMentors] = useState([]);
    const [selectedSupportMentors, setSelectedSupportMentors] = useState([]);

    const [description, setDescription] = useState("");
    const [note, setNote] = useState("");

    const [courseStartDate, setCourseStartDate] = useState(null);
    const [courseEndDate, setCourseEndDate] = useState(null);
    const [registrationStartDate, setRegistrationStartDate] = useState(null);
    const [registrationEndDate, setRegistrationEndDate] = useState(null);

    const [certifications, setCertifications] = useState([{ name: "", logo: "" }]);
    const [currentSyllabusName, setCurrentSyllabusName] = useState("");
    const [syllabus, setSyllabus] = useState(null);

    const [addedby, setAddedBy] = useState("");

    // raw ids for reactive prepopulate
    const [idsToPrepopulate, setIdsToPrepopulate] = useState(null);

    // small option constants
    const scholorTypeOptions = [
        { label: "Day Scholar", value: "day scholar" },
        { label: "Hosteller", value: "hosteller" },
        { label: "All", value: "All" }
    ];
    const genderOptions = [
        { label: "Male", value: "male" },
        { label: "Female", value: "female" },
        { label: "Any", value: "any" }
    ];
    const statusOptions = [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 0 }
    ];
    const registrationStatusOptions = [
        { label: "Open", value: 1 },
        { label: "Closed", value: 0 }
    ];

    // --- load base lists and registration record
    useEffect(() => {
        const curr_user = JSON.parse(localStorage.getItem('authUser'));
        if (curr_user) setAddedBy(curr_user.first_name || "");

        const p1 = axios.get(`${backendUrl}get-courses`).catch(() => ({ data: [] }));
        const p2 = axios.get(`${backendUrl}get-passout_year`).catch(() => ({ data: [] }));
        const p3 = axios.get(`${backendUrl}get-certifications`).catch(() => ({ data: [] }));
        const p4 = axios.get(`${backendUrl}get-colleges`).catch(() => ({ data: { colleges: [] } }));
        const p5 = axios.get(`${backendUrl}get-branches`).catch(() => ({ data: { branches: [] } }));
        const p6 = axios.get(`${backendUrl}get-cashiers`).catch(() => ({ data: { data: [] } }));

        Promise.all([p1, p2, p3, p4, p5, p6])
            .then(([r1, r2, r3, r4, r5, r6]) => {
                if (r1 && r1.status === 200) setCourses(r1.data || []);
                if (r2 && r2.status === 200) setPassoutYearList(r2.data || []);
                if (r3 && r3.status === 200) setCertificationOptions(r3.data || []);
                if (r4 && r4.status === 200) setCollegeList(r4.data.colleges || []);
                if (r5 && r5.status === 200) {
                    const arrayofBranches = r5.data.branches.flatMap(ele => Array.isArray(ele._id) ? ele._id : (ele._id ? [ele._id] : [])).map(b => String(b).trim());
                    setBranchList([...new Set(arrayofBranches)]);
                }
                if (r6 && r6.status === 200) setCashierNames(r6.data.data || []);
                // now fetch registration
                fetchCourseRegistrationData(id);
            })
            .catch(err => {
                console.error('load lists error', err);
                fetchCourseRegistrationData(id); // best-effort
            });
    }, [id]);

    // fetch the registration entry and store raw ids for reactive prepopulation
    const fetchCourseRegistrationData = async (regId) => {
        try {
            const res = await axios.get(`${backendUrl}get-course-registration-by-id/${regId}`);
            if (res.status === 200) {
                const data = res.data.data || {};

                setProgramName(data.program_name || "");
                setAppProgram(data.app_program || "");
                setFee(String(data.fee ?? ""));
                setSeats(String(data.seats ?? ""));
                setDescription(data.description || "");
                setNote(data.note || "");
                setNoOfTerms(String(data.no_of_terms ?? ""));
                setCurrentSyllabusName(data.syllabus || "");
                setEligibleRollNos(Array.isArray(data.eligible_rollNos) ? data.eligible_rollNos.join(',') : (data.eligible_rollNos || ""));

                setSelectedColleges((data.eligible_college || []).map(c => ({ label: c, value: c })));
                setSelectedBranches((data.eligible_branch || []).map(b => ({ label: b, value: b })));
                setSelectedEligibleYears((data.eligible_passout_year || []).map(y => ({ label: String(y), value: y })));

                if (data.cashier_names && Array.isArray(data.cashier_names)) {
                    const formattedCashiers = data.cashier_names.map(c => typeof c === 'object' && c !== null ? { label: c.first_name, value: c.first_name } : { label: c, value: c });
                    setSelectedCashiers(formattedCashiers);
                }

                setCertifications((data.certifications && data.certifications.length > 0) ? data.certifications.map(c => ({ name: c.name, logo: c.logo })) : [{ name: "", logo: "" }]);
                setTermFeeDetails((data.term_fee_details && data.term_fee_details.length > 0) ? data.term_fee_details.map(t => ({ term_name: t.term_name, amount: t.amount, status: t.status, endDate: t.endDate ? moment(t.endDate).format('YYYY-MM-DD') : '' })) : [{ term_name: "", amount: "", status: "", endDate: "" }]);

                if (data.course_start_date) setCourseStartDate(moment(data.course_start_date).toDate());
                if (data.course_end_date) setCourseEndDate(moment(data.course_end_date).toDate());
                if (data.registration_start_date) setRegistrationStartDate(moment(data.registration_start_date).toDate());
                if (data.registration_end_date) setRegistrationEndDate(moment(data.registration_end_date).toDate());

                setIdsToPrepopulate({
                    courseId: data.course,
                    technologyId: data.technology,
                    technologyLogo: data.technology_icon || data.technology_logo,
                    gender: data.gender,
                    scholarType: data.scholar_type,
                    passoutYear: data.passout_year,
                    status: data.status,
                    registrationStatus: data.registration_status,
                    mentors: data.mentors || [],
                    support_mentors: data.support_mentors || []
                });
            }
        } catch (err) {
            console.error('fetch registration error', err);
            toast.error('Failed to fetch course registration data');
        }
    };

    // reactive preselection: course
    useEffect(() => {
        if (!idsToPrepopulate || courses.length === 0) return;
        const course = courses.find(c => String(c._id) === String(idsToPrepopulate.courseId));
        if (course) setSelectedCourse({ label: course.course_name, value: course._id });
    }, [idsToPrepopulate, courses]);

    // when course selected -> load technologies
    useEffect(() => {
        if (!selectedCourse?.value) { setTechnologies([]); setSelectedTechnology(null); return; }
        const load = async () => {
            try {
                const res = await axios.post(`${backendUrl}get-technology-by-course-id`, { course_id: selectedCourse.value });
                if (res.status === 200) setTechnologies(res.data || []);
            } catch (err) { console.error('load tech error', err); }
        };
        load();
    }, [selectedCourse]);

    // preselect technology
    useEffect(() => {
        if (!idsToPrepopulate || technologies.length === 0) return;
        const tech = technologies.find(t => String(t._id) === String(idsToPrepopulate.technologyId));
        if (tech) setSelectedTechnology({ label: tech.technology_name, value: tech._id });
    }, [idsToPrepopulate, technologies]);

    // when technology -> load logos & trainers
    useEffect(() => {
        if (!selectedTechnology?.value) { setTechnologyLogoDetails([]); setSelectedTechnologyLogo(null); setTrainers([]); return; }
        const p1 = axios.get(`${backendUrl}get-technology-icon/${selectedTechnology.value}`).catch(() => ({ data: [] }));
        const p2 = axios.post(`${backendUrl}get-users-by-technology`, { technology_ids: [selectedTechnology.value] }).catch(() => ({ data: [] }));
        Promise.all([p1, p2])
            .then(([r1, r2]) => {
                if (r1 && r1.status === 200) setTechnologyLogoDetails(r1.data || []);
                if (r2 && r2.status === 200) setTrainers(r2.data || []);
            })
            .catch(e => console.error('logos/trainers load', e));
    }, [selectedTechnology]);

    // preselect logo
    useEffect(() => {
        if (!idsToPrepopulate || technologyLogoDetails.length === 0) return;
        const logo = technologyLogoDetails.find(l => l.technology_icon === idsToPrepopulate.technologyLogo || l.technology === idsToPrepopulate.technologyId || l.technology_id === idsToPrepopulate.technologyId);
        if (logo) setSelectedTechnologyLogo({ label: logo.technology_name, value: logo.technology_icon });
    }, [idsToPrepopulate, technologyLogoDetails]);

    // preselect mentors
    useEffect(() => {
        if (!idsToPrepopulate || trainers.length === 0) return;
        const mapToOptions = (saved) => {
            if (!saved || !Array.isArray(saved)) return [];
            return saved.map(item => {
                const idVal = (typeof item === 'object' && item !== null) ? (item._id || item.first_name) : item;
                const found = trainers.find(t => String(t._id) === String(idVal) || t.first_name === idVal);
                if (found) return { label: found.first_name, value: found.first_name };
                return { label: String(idVal), value: String(idVal) };
            });
        };
        setSelectedMentors(mapToOptions(idsToPrepopulate.mentors));
        setSelectedSupportMentors(mapToOptions(idsToPrepopulate.support_mentors));
    }, [idsToPrepopulate, trainers]);

    // passout year & other preselects
    useEffect(() => {
        if (!idsToPrepopulate || passoutYearList.length === 0) return;
        if (idsToPrepopulate.passoutYear) {
            const y = passoutYearList.find(p => String(p.value) === String(idsToPrepopulate.passoutYear) || String(p.label) === String(idsToPrepopulate.passoutYear));
            if (y) setSelectedPassoutYear({ label: y.label, value: y.value });
        }
        if (idsToPrepopulate.gender) {
            const g = genderOptions.find(o => String(o.value) === String(idsToPrepopulate.gender).toLowerCase());
            if (g) setSelectedGender(g);
        }
        // if (idsToPrepopulate.scholarType) {
        //     const s = scholorTypeOptions.find(o => String(o.value) === String(idsToPrepopulate.scholarType));
        //     if (s) setSelectedScholarType(s);
        // }
        if (typeof idsToPrepopulate.status !== 'undefined') {
            const st = statusOptions.find(o => String(o.value) === String(idsToPrepopulate.status));
            if (st) setSelectedStatus(st);
        }
        if (typeof idsToPrepopulate.registrationStatus !== 'undefined') {
            const rs = registrationStatusOptions.find(o => String(o.value) === String(idsToPrepopulate.registrationStatus));
            if (rs) setSelectedRegistrationStatus(rs);
        }
    }, [idsToPrepopulate, passoutYearList]);

    // UI options arrays
    const courseOptions = courses.map(c => ({ label: c.course_name, value: c._id }));
    const technologyOptions = technologies.map(t => ({ label: t.technology_name, value: t._id }));
    const technologyLogoOptions = technologyLogoDetails.map(l => ({ label: l.technology_name, value: l.technology_icon }));
    const passoutYearOptions = passoutYearList.map(p => ({ label: p.label, value: p.value }));
    const collegeOptions = collegeList.map(c => ({ label: c._id, value: c._id }));
    const branchOptions = branchList.map(b => ({ label: b, value: b }));
    const cashierOptions = cashierNames.map(c => ({ label: `${c.first_name} - ${c.college}`, value: c.first_name }));
    const mentorOptions = trainers.map(t => ({ label: t.first_name, value: t.first_name }));
    const supportMentorOptions = mentorOptions;

    // term name options
    useEffect(() => {
        if (!noOfTerms) { setTermNameOptions([]); return; }
        const generated = [];
        for (let i = 1; i <= parseInt(noOfTerms, 10); i++) generated.push({ label: `Term ${i}`, value: `Term ${i}` });
        setTermNameOptions(generated);
    }, [noOfTerms]);

    // helpers (cleaning)
    const cleanText = (val) => {
        let v = val.replace(/[^a-zA-Z0-9\s-]/g, "");
        v = v.replace(/^\s+/, "");
        return v.slice(0, 25);
    };
    const cleanDescription = (val) => val.replace(/[^a-zA-Z0-9\s.,-]/g, "");
    const cleanNumber = (val) => val.replace(/[^0-9]/g, "").replace(/^0+/, "");
    const cleanRollNos = (val) => val.replace(/\s+/g, "").replace(/[^a-zA-Z0-9,]/g, "");

    const handleTermFeeChange = (index, field, value) => {
        const copy = [...termFeeDetails];
        copy[index] = { ...copy[index], [field]: (field === 'amount' || field === 'status') ? Number(value) : value };
        setTermFeeDetails(copy);
    };
    const addTermFeeField = () => {
        if (!noOfTerms || parseInt(noOfTerms, 10) <= 0) return toast.error("Please specify the number of terms before adding fee details.");
        if (termFeeDetails.length >= parseInt(noOfTerms, 10)) return toast.error(`You can't add more than ${noOfTerms} terms.`);
        const last = termFeeDetails[termFeeDetails.length - 1];
        if (!last.term_name || !last.amount) return toast.error("Please fill out all fields of the current term before adding a new one.");
        setTermFeeDetails([...termFeeDetails, { term_name: "", amount: "", status: "", endDate: "" }]);
    };
    const removeTermFeeField = (index) => { const c = [...termFeeDetails]; c.splice(index, 1); setTermFeeDetails(c); };

    const handleCertificationChange = (index, value) => {
        const selected = certificationOptions.find(c => c.certification_name === value);
        const updated = [...certifications];
        updated[index] = { name: selected?.certification_name || "", logo: selected?.certification_icon || "" };
        setCertifications(updated);
    };
    const handleAddCertification = () => { const last = certifications[certifications.length - 1]; if (!last || (last.name && last.logo)) setCertifications([...certifications, { name: "", logo: "" }]); else toast.error("Please fill out the current certification before adding a new one."); };
    const handleRemoveCertification = (i) => { const c = [...certifications]; c.splice(i, 1); setCertifications(c); };

    // submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();

        // validations
        if (!selectedCourse?.value) return toast.error("Please select a course.");
        if (!selectedTechnology?.value) return toast.error("Please select a technology.");
        if (!programName) return toast.error("Program name is required.");
        if (!appProgram) return toast.error("App Program is required.");
        if (!fee) return toast.error("Fee is required.");
        if (!seats) return toast.error("Seats are required.");
        if (!noOfTerms) return toast.error("No of terms is required.");

        if (parseInt(noOfTerms) !== termFeeDetails.length) return toast.error("The number of terms must match the number of term fee details.");
        const totalTermAmount = termFeeDetails.reduce((s, t) => s + Number(t.amount || 0), 0);
        if (Number(fee) !== totalTermAmount) return toast.error(`Total term amount (${totalTermAmount}) must equal the Fee (${fee}).`);

        const cStart = new Date(courseStartDate);
        const cEnd = new Date(courseEndDate);
        const rStart = new Date(registrationStartDate);
        const rEnd = new Date(registrationEndDate);

        if (rEnd <= rStart) return toast.error("Registration End Date must be GREATER than Registration Start Date.");
        if (cStart <= rEnd) return toast.error("Course Start Date must be GREATER than Registration End Date.");
        if (cEnd <= cStart) return toast.error("Course End Date must be GREATER than Course Start Date.");

        const formData = new FormData();
        formData.append("course", selectedCourse.value);
        formData.append("technology", selectedTechnology.value);
        formData.append("technology_icon", selectedTechnologyLogo?.value || "");
        formData.append("app_program", appProgram);
        formData.append("program_name", programName);
        formData.append("fee", fee);
        formData.append("seats", seats);
        formData.append("no_of_terms", noOfTerms);
        formData.append("gender", selectedGender?.value || "");
        // formData.append("scholar_type", selectedScholarType?.value || "");
        formData.append("passout_year", selectedPassoutYear?.value || "");
        formData.append("status", selectedStatus?.value ?? "");
        formData.append("registration_status", selectedRegistrationStatus?.value ?? 0);
        formData.append("description", description || "");
        formData.append("note", note || "");
        formData.append("added_by", addedby || "");
        formData.append("batch_tag", "");

        formData.append("registration_start_date", rStart.toISOString());
        formData.append("registration_end_date", rEnd.toISOString());
        formData.append("course_start_date", cStart.toISOString());
        formData.append("course_end_date", cEnd.toISOString());

        formData.append("eligible_rollNos", JSON.stringify(eligibleRollNos.split(',').map(r => r.trim()).filter(r => r)));
        formData.append("eligible_college", JSON.stringify(selectedColleges.map(x => x.value)));
        formData.append("eligible_branch", JSON.stringify(selectedBranches.map(x => x.value)));
        formData.append("eligible_passout_year", JSON.stringify(selectedEligibleYears.map(x => x.value)));
        formData.append("mentors", JSON.stringify(selectedMentors.map(m => m.value)));
        formData.append("support_mentors", JSON.stringify(selectedSupportMentors.map(m => m.value)));
        formData.append("cashier_names", JSON.stringify(selectedCashiers.map(c => c.value)));
        formData.append("term_fee_details", JSON.stringify(termFeeDetails));
        formData.append("certifications", JSON.stringify(certifications.filter(cert => cert.name && cert.logo)));

        if (syllabus) formData.append("syllabus", syllabus);
        else formData.append("syllabus", currentSyllabusName || "");
        // Preview all form data before submit
        const submitPreview = {
            course: selectedCourse?.value,
            technology: selectedTechnology?.value,
            technology_icon: selectedTechnologyLogo?.value,
            app_program: appProgram,
            program_name: programName,
            fee,
            seats,
            no_of_terms: noOfTerms,
            gender: selectedGender?.value,
            // scholar_type: selectedScholarType?.value,
            passout_year: selectedPassoutYear?.value,
            status: selectedStatus?.value,
            registration_status: selectedRegistrationStatus?.value,
            description,
            note,
            added_by: addedby,
            eligible_rollNos: eligibleRollNos.split(",").map(r => r.trim()).filter(r => r),
            eligible_college: selectedColleges.map(x => x.value),
            eligible_branch: selectedBranches.map(x => x.value),
            eligible_passout_year: selectedEligibleYears.map(x => x.value),
            mentors: selectedMentors.map(m => m.value),
            support_mentors: selectedSupportMentors.map(m => m.value),
            cashier_names: selectedCashiers.map(c => c.value),
            term_fee_details: termFeeDetails,
            certifications: certifications,
            registration_start_date: registrationStartDate,
            registration_end_date: registrationEndDate,
            course_start_date: courseStartDate,
            course_end_date: courseEndDate,
            syllabus: syllabus ? syllabus.name : currentSyllabusName
        };

        console.log("🔍 SUBMIT PREVIEW:", submitPreview);

        try {
            const response = await axios.put(`${backendUrl}edit-course-registration/${id}`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            if (response.status === 200) {
                toast.success("Course registration updated successfully!");
                setTimeout(() => navigate("/course-registrations-list"), 1000);
            }
        } catch (err) {
            console.error("Update error:", err);
            toast.error(err.response?.data?.message || "Internal server error.");
        }
    };

    return (
        <>
            <Row>
                <ToastContainer position="top-right" autoClose={5000} transition={Bounce} />
                <Col xl="12">
                    <Card>
                        <CardBody>
                            <h4 className="card-title">Edit Course Registration Data</h4>

                            <form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md="4">
                                        <Label>Select Course <span className="text-danger">*</span></Label>
                                        <Select value={selectedCourse} isDisabled={true} onChange={(o) => { setSelectedCourse(o); setSelectedTechnology(null); setSelectedTechnologyLogo(null); setTechnologies([]); setTechnologyLogoDetails([]); }} options={courseOptions} classNamePrefix="select2-selection" />
                                    </Col>

                                    <Col md="4">
                                        <Label>Select Technology <span className="text-danger">*</span></Label>
                                        <Select value={selectedTechnology} isDisabled={true} onChange={(o) => { setSelectedTechnology(o); setSelectedTechnologyLogo(null); }} options={technologyOptions} classNamePrefix="select2-selection" />
                                    </Col>

                                    <Col md="3">
                                        <Label>Technology Logo <span className="text-danger">*</span></Label>
                                        <Select value={selectedTechnologyLogo} isDisabled={true} onChange={setSelectedTechnologyLogo} options={technologyLogoOptions} classNamePrefix="select2-selection" />
                                    </Col>

                                    <Col md="1">
                                        {selectedTechnologyLogo?.value && <img src={`${backendImgUrl}technology-icons/${selectedTechnologyLogo.value}`} alt="logo" style={{ width: 40, height: 40, objectFit: "contain" }} className="me-2 mt-4" />}
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md="4">
                                        <Label>Program Name <span className="text-danger">*</span></Label>
                                        <input name="program_name" className="form-control" value={programName} onChange={(e) => setProgramName(cleanText(e.target.value))} maxLength={25} />
                                    </Col>
                                    <Col md="4">
                                        <Label>App Program <span className="text-danger">*</span></Label>
                                        <input name="app_program" className="form-control" value={appProgram} onChange={(e) => setAppProgram(cleanText(e.target.value))} maxLength={25} />
                                    </Col>
                                    <Col md="4">
                                        <Label>No Of Terms <span className="text-danger">*</span></Label>
                                        <input name="no_of_terms" className="form-control" type="number" min={1} max={10} value={noOfTerms} onChange={(e) => setNoOfTerms(e.target.value)} />
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md="4">
                                        <Label>Fee <span className="text-danger">*</span></Label>
                                        <input name="fee" className="form-control" value={fee} onChange={(e) => setFee(cleanNumber(e.target.value))} />
                                    </Col>
                                    <Col md="4">
                                        <Label>Seats <span className="text-danger">*</span></Label>
                                        <input name="seats" className="form-control" value={seats} onChange={(e) => setSeats(cleanNumber(e.target.value))} />
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md="4">
                                        <Label>Gender</Label>
                                        <Select value={selectedGender} onChange={setSelectedGender} options={genderOptions} />
                                    </Col>
                                    <Col md="4">
                                        <Label>Passout Year</Label>
                                        <Select value={selectedPassoutYear} onChange={setSelectedPassoutYear} options={passoutYearOptions} />
                                    </Col>
                                    {/* <Col md="4">
                                        <Label>Scholar Type</Label>
                                        <Select value={selectedScholarType} onChange={setSelectedScholarType} options={scholorTypeOptions} />
                                    </Col> */}
                                </Row>

                                <Row className="mt-3">
                                    <Col md="6">
                                        <Label>Eligible Roll Nos (Alphanumeric & Comma)</Label>
                                        <textarea style={{ resize: "none", overflowY: "auto", overflowX: "hidden" }}
                                            className="form-control" rows={3} value={eligibleRollNos} onChange={(e) => setEligibleRollNos(cleanRollNos(e.target.value))} />
                                    </Col>
                                    <Col md="6">
                                        <Label>Eligible Colleges</Label>
                                        <Select isMulti options={collegeOptions} value={selectedColleges} onChange={setSelectedColleges} />
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md="6">
                                        <Label>Eligible Branches</Label>
                                        <Select isMulti options={branchOptions} value={selectedBranches} onChange={setSelectedBranches} />
                                    </Col>
                                    <Col md="6">
                                        <Label>Eligible Passout Years</Label>
                                        <Select isMulti options={passoutYearOptions} value={selectedEligibleYears} onChange={setSelectedEligibleYears} />
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md="6">
                                        <Label>Registration Start Date</Label>
                                        <Flatpickr className="form-control" value={registrationStartDate} onChange={(d) => setRegistrationStartDate(d[0] || null)} options={{ dateFormat: "Y-m-d", minDate: "today" }} />
                                    </Col>
                                    <Col md="6">
                                        <Label>Registration End Date</Label>
                                        <Flatpickr className="form-control" value={registrationEndDate} onChange={(d) => setRegistrationEndDate(d[0] || null)} options={{ dateFormat: "Y-m-d", minDate: "today" }} />
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md="6">
                                        <Label>Course Start Date</Label>
                                        <Flatpickr className="form-control" value={courseStartDate} onChange={(d) => setCourseStartDate(d[0] || null)} options={{ dateFormat: "Y-m-d", minDate: "today" }} />
                                    </Col>
                                    <Col md="6">
                                        <Label>Course End Date</Label>
                                        <Flatpickr className="form-control" value={courseEndDate} onChange={(d) => setCourseEndDate(d[0] || null)} options={{ dateFormat: "Y-m-d", minDate: "today" }} />
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md="6">
                                        <Label>Mentors</Label>
                                        <Select isMulti options={mentorOptions} value={selectedMentors} onChange={setSelectedMentors} />
                                    </Col>
                                    <Col md="6">
                                        <Label>Support Mentors</Label>
                                        <Select isMulti options={supportMentorOptions} value={selectedSupportMentors} onChange={setSelectedSupportMentors} />
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md="6">
                                        <Label>Syllabus</Label>
                                        <input type="file" className="form-control" onChange={(e) => setSyllabus(e.target.files[0])} />
                                        {currentSyllabusName && <p className="mt-2">Current Syllabus: <a href={`${backendImgUrl}course-syllabuss/${currentSyllabusName}`} target="_blank" rel="noopener noreferrer">{currentSyllabusName}</a></p>}
                                    </Col>

                                    <Col md="6">
                                        <Label>Certifications</Label>
                                        {certifications.map((cert, idx) => (
                                            <div key={idx} className="d-flex align-items-center mb-2">
                                                <select className="form-control me-2" value={cert.name} onChange={(e) => handleCertificationChange(idx, e.target.value)}>
                                                    <option value="">Select Certification</option>
                                                    {certificationOptions.map(c => (<option key={c._id} value={c.certification_name}>{c.certification_name}</option>))}
                                                </select>
                                                {cert.logo && <img src={`${backendImgUrl}certification-icons/${cert.logo}`} alt="cert" style={{ width: 40, height: 40, objectFit: "contain" }} className="me-2" />}
                                                {idx > 0 && <Button color="danger" size="sm" onClick={() => handleRemoveCertification(idx)}>Remove</Button>}
                                            </div>
                                        ))}
                                        <Button color="primary" size="sm" onClick={handleAddCertification}>Add Certification</Button>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md="6">
                                        <Label>Select Cashiers  <span className="text-danger">*</span></Label>
                                        <Select isMulti options={cashierOptions} value={selectedCashiers} onChange={setSelectedCashiers} />
                                    </Col>

                                    <Col md="6">
                                        <Label>Term Fee Details</Label>
                                        {termFeeDetails.map((tf, idx) => (
                                            <div key={idx} className="border rounded p-2 mb-2">
                                                <select className="form-control mb-2" value={tf.term_name} onChange={(e) => handleTermFeeChange(idx, 'term_name', e.target.value)}>
                                                    <option value="">Select Term</option>
                                                    {termNameOptions.filter(opt => !termFeeDetails.some((t, i) => t.term_name === opt.value && i !== idx)).map(opt => (<option key={opt.value} value={opt.value}>{opt.label}</option>))}
                                                </select>
                                                <input className="form-control mb-2" type="number" min="1" value={tf.amount} onChange={(e) => handleTermFeeChange(idx, 'amount', e.target.value.replace(/\D/g, ''))} />
                                                <select className="form-control mb-2" value={tf.status} onChange={(e) => handleTermFeeChange(idx, 'status', e.target.value)}>
                                                    <option value="">Select Status</option>
                                                    <option value={1}>Active</option>
                                                    <option value={0}>Inactive</option>
                                                </select>
                                                {idx > 0 && <Button color="danger" size="sm" onClick={() => removeTermFeeField(idx)}>Remove</Button>}
                                            </div>
                                        ))}
                                        <Button color="primary" size="sm" onClick={addTermFeeField}>+ Add Term Fee</Button>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md="6">
                                        <Label>Description</Label>
                                        <textarea style={{ resize: "none", overflowY: "auto", overflowX: "hidden" }}
                                            className="form-control" rows={3} value={description} onChange={(e) => setDescription(cleanDescription(e.target.value))} />
                                    </Col>
                                    <Col md="6">
                                        <Label>Note</Label>
                                        <textarea style={{ resize: "none", overflowY: "auto", overflowX: "hidden" }}
                                            className="form-control" rows={3} value={note} onChange={(e) => setNote(cleanDescription(e.target.value))} />
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md="6">
                                        <Label>Payment Status</Label>
                                        <Select value={selectedStatus} onChange={setSelectedStatus} options={statusOptions} />
                                    </Col>
                                    <Col md="6">
                                        <Label>Registration Status</Label>
                                        <Select value={selectedRegistrationStatus} onChange={setSelectedRegistrationStatus} options={registrationStatusOptions} />
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col>
                                        <Button color="primary" type="submit">Update</Button>
                                    </Col>
                                </Row>
                            </form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default EditCourseRegistration;
